export const POINTS_HISTORY_ENTRY_TYPE = {
  INVOICE: 'invoice',
  // added once at the points migration so existing customers kept their level
  RETENTION: 'retention',
} as const;

export type PointsHistoryEntryType = typeof POINTS_HISTORY_ENTRY_TYPE[keyof typeof POINTS_HISTORY_ENTRY_TYPE];

export type PointsHistoryEntry = {
  type: PointsHistoryEntryType;
  orderNumber: string | null;
  invoiceNumber: string | null;
  // YYYY-MM-DD
  date: string;
  // negative for returns
  points: number;
  amount: number | null;
  currency: string | null;
};
